export const ExportSectionHeading = ({
  heading,
  children,
  contained = true,
}: {
  heading: string
  children?: React.ReactNode
  contained?: boolean
}) => {
  const headingEl = (
    <div className='mb-4 mt-6 border-b border-main-border-default pb-2'>
      <h2 className='text-2xl'>{heading}</h2>
    </div>
  )

  if (!contained) {
    return headingEl
  }

  return (
    <div className='mx-8'>
      {headingEl}
      {children}
    </div>
  )
}
